import { render } from "./CabeceraHeader.vue?vue&type=template&id=51363b80"
import script from "./CabeceraHeader.vue?vue&type=script&lang=js"
export * from "./CabeceraHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__